import React from 'react';
import { Activity, RefreshCw, Smartphone, Radio, Database } from 'lucide-react';
import { useTelemetry } from '../context/TelemetryContext';

export default function Header(props) {
  const telemetry = useTelemetry();

  const isLiveBackend = props.isLiveBackend ?? telemetry.isLiveBackend;
  const forceMock = props.forceMock ?? telemetry.forceMock;
  const setForceMock = props.setForceMock ?? telemetry.setForceMock;
  const mno = props.mno ?? telemetry.mno;
  const setMno = props.setMno ?? telemetry.setMno;
  const route = props.route ?? telemetry.route;
  const setRoute = props.setRoute ?? telemetry.setRoute;
  const onRefresh = props.onRefresh ?? telemetry.loadDashboardData;
  const isRefreshing = props.isRefreshing ?? telemetry.isRefreshing;
  const onOpenSimulator = props.onOpenSimulator ?? (() => telemetry.setIsSimulatorDrawerOpen(true));
  const mnoList = props.mnoList ?? telemetry.mnoList ?? [];

  return (
    <header className="glass-card" style={{ padding: '18px 24px', background: '#FFFFFF' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
        
        {/* Brand & Status */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <div style={{
            width: '42px',
            height: '42px',
            borderRadius: '10px',
            background: 'linear-gradient(135deg, #F84122 0%, #E65100 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 14px rgba(248, 65, 34, 0.35)'
          }}>
            <Activity size={22} color="#FFFFFF" />
          </div>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <h1 style={{ fontSize: '18px', fontWeight: '800', letterSpacing: '-0.02em', margin: 0, color: '#0F172A' }}>
                CestaConnect
              </h1>
              <span style={{ fontSize: '12px', color: '#64748B', fontWeight: '500' }}>USSD Operations & Telemetry</span>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '2px' }}>
              <span className={`live-indicator ${isLiveBackend && !forceMock ? 'online' : 'mock'}`}>
                <span className="dot" />
                {isLiveBackend && !forceMock ? 'MongoDB Live (Port 8145)' : 'Simulated Telemetry (Demo Mode)'}
              </span>
              <button
                onClick={() => setForceMock(!forceMock)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#F84122',
                  fontSize: '11px',
                  fontWeight: '600',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                {forceMock ? 'Switch to Live' : 'Force Mock'}
              </button>
            </div>
          </div>
        </div>

        {/* Global Filters & Controls */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
          
          {/* MNO Filter */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <Radio size={14} color="#64748B" />
            <select
              className="custom-select"
              value={mno}
              onChange={(e) => setMno(e.target.value)}
              title="Filter by MNO"
            >
              <option value="ALL">All MNOs</option>
              {mnoList?.map((cfg) => (
                <option key={cfg.code || cfg.id} value={cfg.code}>
                  {cfg.displayName || cfg.code}
                </option>
              ))}
            </select>
          </div>

          {/* Core Route Filter */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <Database size={14} color="#64748B" />
            <select
              className="custom-select"
              value={route}
              onChange={(e) => setRoute(e.target.value)}
              title="Filter by Route"
            >
              <option value="ALL">All Routes</option>
              <option value="HELLO_MONEY">Hello Money</option>
              <option value="DIGITAL_WALLET">Digital Wallet</option>
              <option value="USSD_WRAPPER">USSD Wrapper</option>
            </select>
          </div>

          {/* Refresh Button */}
          <button
            className="btn-secondary"
            onClick={onRefresh}
            disabled={isRefreshing}
            title="Refresh dashboard metrics"
          >
            <RefreshCw size={14} style={{ animation: isRefreshing ? 'spin 1s linear infinite' : 'none', color: '#0F172A' }} />
            <span>Refresh</span>
          </button>

          {/* USSD Dialogue Simulator Launcher */}
          <button
            className="btn-primary"
            onClick={onOpenSimulator}
          >
            <Smartphone size={15} />
            <span>Live USSD Simulator</span>
          </button>

        </div>
      </div>
    </header>
  );
}
